<template>
  <div id="main">
    <div id="map_detail_box">
      <div class="title-wrap" id="map_detail_product_data">
        <div class="title-name" @click="clickBack">
          <i class="el-icon-arrow-left"></i>
          返回上一页
        </div>
      </div>

      <div class="overview" v-loading="loading">
        <HelpTip class="help-right">
          <pre slot="regular" class="detail-des">
作品下载总次数：地图作品被玩家下载的累计次数
作品浏览总次数：地图作品详情页（工坊或大厅内）被玩家查看的累计次数
游戏总次数：地图作品被玩家进入游玩累计次数
游戏总时长(分钟)：地图作品被玩家进入停留游玩的累计时长
人均游玩时长(分钟)：地图作品被玩家进入停留游玩的人均时长
游戏人数：地图作品被玩家进入游玩的累计人数
评论数：地图作品被玩家评论的累计次数
收藏数：地图作品被玩家收藏的累计次数
投块数：地图作品获得投块的累计数
点赞数：地图作品被玩家点赞的累计次数
广告总收入：玩家观看作品内的广告后产生的收益
广告曝光总次数：地图作品内的玩家点击播放广告的次数
贡献点数量：玩家使用迷你币消费您的作品或道具
迷你点数量：玩家使用迷你点购买了作品或资源
迷你豆数量：玩家使用迷你豆购买了作品或资源
贡献点付费率：贡献点付费人数/游戏人数
贡献点ARPU：每用户平均贡献点收益，即贡献点/游玩人数
贡献点ARPPU：每付费用户平均贡献点收益，即贡献点收入/迷你币付费人数
迷你点ARPU：每用户平均迷你点收益，即迷你点收入/游玩人数
迷你点ARPPU：每付费用户平均迷你点收益，即迷你点收入/迷你点付费人数
迷你币付费数量（分成前）：新增：与平台分成前，当天购买的迷你币数量(分成前）
迷你币付费人数：新增：购买迷你币的人数（去重）
次留：新增：统计日的玩家，在未来第二日的留存率
三留：新增：统计日的玩家，在未来第三日的留存率
七留：新增：统计日的玩家，在未来第七日的留存率
三十留：新增：统计日的玩家，在未来第三十日的留存率</pre
          >
        </HelpTip>
        <el-dropdown class="close-cs-room">
          <span class="el-dropdown-link">
            <i class="el-icon-setting el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="csRoomVisible = true">
              关闭房间
            </el-dropdown-item>
            <el-dropdown-item @click.native="showMapBlackList = true">
              地图黑名单（仅云服可用）
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="basic-info" v-if="isShowMapInfo">
          <div class="map-info">
            <div class="map-img-wrap">
              <img class="map-img" :src="mapInfo.url" />
              <img
                v-if="mapInfo.ctype === 1"
                class="corner"
                src="@/assets/images/corner_works_map.png"
                alt="corner"
              />
              <img
                v-if="mapInfo.ctype === 2"
                class="corner"
                src="@/assets/images/corner_works_game.png"
                alt="corner"
              />
            </div>
            <div class="map-detail">
              <div>
                <p class="map-name">{{ mapInfo.name }}</p>
                <span class="map-type">{{
                  mapInfo.label | regroupMapType
                }}</span>
              </div>
              <div class="map-topic" v-if="mapInfo.memo">
                #{{ mapInfo.memo }}#
              </div>
              <div class="map-status">
                <span class="map-status">审核状态:</span>
                {{ mapInfo.open_svr | regroupMapStatus }}
              </div>
              <div class="map-update">
                更新时间：{{ mapInfo.last_time | regroupDate }}
              </div>
            </div>
          </div>
        </div>
        <div class="content-wrap">
          <div class="data-wrap">
            <div class="complex-wrap">
              <div class="date-label">过去30日累计数据</div>
              <!-- 作品数据模块 -->
              <div class="card-wrap">
                <div class="card-box">
                  <div class="title">作品数据</div>
                  <div id="card">
                    <cpn-cards
                      v-for="(item, index) in productData"
                      class="card-wrap"
                      :data="item"
                      :class="{ 'active-card': activeCard == index }"
                      @click.native="changeCard(index)"
                      :key="index"
                    >
                    </cpn-cards>
                  </div>
                </div>
                <!-- 用户数据模块 -->
                <div class="card-box">
                  <div class="title">用户数据</div>
                  <div id="card">
                    <cpn-cards
                      v-for="(item, index) in membersData"
                      class="card-wrap"
                      :data="item"
                      :class="{ 'active-card': activeCard == index + 2 }"
                      @click.native="changeCard(index)"
                      :key="index"
                    >
                    </cpn-cards>
                  </div>
                </div>
                <!-- 互动数据模块 -->
                <div class="card-box">
                  <div class="title">互动数据</div>
                  <div id="card">
                    <cpn-cards
                      v-for="(item, index) in overviewData"
                      class="card-wrap"
                      :data="item"
                      :class="{ 'active-card': activeCard == index + 7 }"
                      @click.native="changeCard(index)"
                      :key="index"
                    >
                    </cpn-cards>
                  </div>
                </div>
                <!-- 收益数据模块 -->
                <div class="card-box">
                  <div class="title">收入数据</div>
                  <div id="card">
                    <cpn-cards
                      v-for="(item, index) in incomeData"
                      class="card-wrap"
                      :data="item"
                      :class="{ 'active-card': activeCard == index + 10 }"
                      @click.native="changeCard(index)"
                      :key="index"
                    >
                    </cpn-cards>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <daysDetail></daysDetail>
          <resourceExposureData></resourceExposureData>
          <div class="charts-detail-wrap" id="map_detail_product_detail_data">
            <h2>作品详细数据</h2>
            <div class="charts-chooseDay">
              <!-- 自由选择日期 -->
              <div class="date-box">
                <div class="data-filter">
                  <span class="mgr25">选择日期</span>
                  <el-date-picker
                    v-model="DateData"
                    type="daterange"
                    align="left"
                    unlink-panels
                    range-separator="~"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="timestamp"
                    :picker-options="DatapickerOptions"
                  >
                  </el-date-picker>
                  <el-button
                    @click="handlePDateBtnClicked"
                    class="search_btn"
                    type="info"
                    >查找</el-button
                  >
                </div>
                <!--固定周期切换-->
                <div class="date-wrap">
                  <el-radio-group
                    v-model="dayNum"
                    style="margin-bottom: 30px"
                    @change="changeDate"
                  >
                    <el-radio-button label="7">7天</el-radio-button>
                    <el-radio-button label="30">30天</el-radio-button>
                    <el-radio-button label="90">90天</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div class="download-wrap" @click="exportFn">
                <img src="@/assets/images/icon_export.png" />
                <span>导出数据</span>
              </div>
              <!-- 全量开放导出功能 v-if="export_custom" -->
              <div class="download-wrap" @click="exportCustomFn">
                <img src="@/assets/images/icon_export.png" />
                <span>导出自定义数据</span>
              </div>
            </div>
            <!-- 折线图 -->
            <div
              v-loading="chartLoadingArr[index].state"
              class="charts-detail"
              v-for="(chart, index) in chartsArr"
              :key="index"
            >
              <div class="title">{{ chart.title }}</div>
              <span
                @click="chooseLabelFn(index, item.id)"
                :class="{ 'active-chart-table': chart.value == item.id }"
                :key="item.id"
                class="btn-option"
                v-for="item in chart.label"
                >{{ item.name }}</span
              >
              <!-- 贡献点费率修改百分比: chart.value === 18 -->
              <ve-line
                :extend="chartExtend"
                v-if="chart.data.rows.length"
                :data="chart.data"
                :legend-visible="false"
                :settings="{
                  digit: 4,
                  yAxisType: chart.value === 18 ? ['percent'] : '',
                }"
              ></ve-line>
              <div class="img-no-data" v-else>
                <img src="../../assets/images/img_map_no_data.png" />
                <p>您暂时还没有数据呢~</p>
              </div>
            </div>
          </div>
        </div>
        <productDetail :mapId="mapId"></productDetail>
        <kvDataDetail></kvDataDetail>
        <logData></logData>
        <kvRollbackData></kvRollbackData>
      </div>
      <el-dialog title="关闭选项" :visible.sync="csRoomVisible" width="400px">
        <div>
          <el-input
            @input="filterCloseTime"
            style="width: 100px"
            v-model="closeTime"
            placeholder="0-5分钟"
          />
          分钟后关闭当前地图的所有房间。
        </div>
        <p style="margin-top: 15px">
          <a
            class="link-txt"
            target="_blank"
            href="https://dev-wiki.mini1.cn/news/2311"
          >
            查看关闭房间说明
          </a>
        </p>
        <div slot="footer" class="dialog-footer">
          <span style="margin-right: 35px; font-weight: bold">
            *选择0分钟会在3秒后关闭
          </span>
          <el-button @click="csRoomVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitCloseRoom">确认</el-button>
        </div>
      </el-dialog>
      <mapBlackList
        :show="showMapBlackList"
        :mapId="mapId"
        @close="showMapBlackList = false"
      ></mapBlackList>
    </div>
  </div>
</template>

<script>
import HelpTip from '@/components/HelpTip';
import productDetail from './components/productDetail.vue';
import kvDataDetail from './components/kvDataDetail.vue';
import logData from './components/logData.vue';
import kvRollbackData from './components/kvRollbackData.vue';
import daysDetail from './components/daysDetail.vue';
import resourceExposureData from './components/resource-exposure-data.vue';
import cpnCards from './components/cpn-cards.vue';
import mapBlackList from './components/mapBlackList.vue';
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
import {
  getMapDetail,
  getMapDiagram,
  exportMapData,
  exportMapCustomData,
  getSinMotivate,
  getExportsureData,
  setCloseRoom,
} from '@/api/charts';
// import cpnDetailTable from './components/cpn-detailTable.vue';
import { chartExtend } from './components/chartsStyle';
// import Table from '../../components/table';
// import exposureDetail from './exposureDetail.vue';
export default {
  components: {
    HelpTip,
    cpnCards,
    productDetail,
    kvDataDetail,
    daysDetail,
    resourceExposureData,
    logData,
    kvRollbackData,
    mapBlackList,
    // inPurchase,
    // 'cpn-detailTable': cpnDetailTable
    // exposureDetail
  },
  data() {
    return {
      loading: false,
      csRoomVisible: false,
      showMapBlackList: false,
      chartLoadingArr: [
        { state: false },
        { state: false },
        { state: false },
        { state: false },
      ],
      closeTime: '',
      productData: [],
      membersData: [],
      overviewData: [],
      incomeData: [],
      activeLabel: 0,
      mapData: {},
      vid: 1,
      single: {},
      profitData: {},
      mapId: '',
      activeCard: 0,
      mapInfo: {},
      export_custom: false,
      isShowMapInfo: false,
      dayNum: 7,
      productDate: [],
      chartsArr: [
        {
          title: '作品相关数据',
          value: 1,
          label: [
            { id: 1, name: '作品下载次数' },
            { id: 2, name: '作品浏览次数' },
            // { id: 16, name: '人均游玩时长' }
          ],
          data: {
            columns: ['日期', '数据'],
            rows: [],
          },
        },
        {
          title: '用户相关数据',
          value: 3,
          label: [
            // { id: 3, name: '游戏总人数' },
            { id: 3, name: '游戏次数' },
            { id: 4, name: '游戏时长(分钟)' },
            { id: 16, name: '人均游玩时长(分钟)' },
            { id: 17, name: '游戏人数' },
            // { id: 7, name: '新增用户' }
            // { id: 16, name: '人均游玩时长' }
          ],
          data: {
            columns: ['日期', '数据'],
            rows: [],
          },
        },
        {
          title: '互动相关数据',
          value: 5,
          label: [
            { id: 5, name: '评论数' },
            { id: 8, name: '收藏数' },
            { id: 6, name: '投块数' },
            { id: 7, name: '点赞数' },
          ],
          data: {
            columns: ['日期', '数据'],
            rows: [],
          },
        },
        {
          title: '收入相关数据',
          value: 9,
          label: [
            { id: 9, name: '广告收入' },
            // { id: 12, name: '会员收入' },
            { id: 14, name: '广告曝光次数' },
            // { id: 14, name: '会员免广告曝光次数' },
            { id: 10, name: '贡献点数量' },
            { id: 11, name: '迷你豆数量' },
            { id: 12, name: '迷你点数量' },
            { id: 18, name: '贡献点付费率', percent: 'percent' },
            { id: 19, name: 'ARPU' },
            { id: 20, name: 'ARPPU' },
          ],
          data: {
            columns: ['日期', '数据'],
            rows: [],
          },
        },
      ],
      analysisArr: [
        {
          title: '用户活跃相关数据',
          value: 1,
          label: [
            { id: 1, name: '人均游玩次数' },
            { id: 2, name: '人均游玩时长(分钟)' },
            // { id: 16, name: '人均游玩时长' }
          ],
          // 折线图数据
          data: {
            columns: ['日期', '数据'],
            rows: [],
          },
        },
        {
          title: '用户留存相关数据',
          value: 3,
          label: [
            // { id: 3, name: '新增用户' },
            { id: 4, name: '新增次日留存' },
            { id: 5, name: '新增次周留存' },
            { id: 6, name: '新增活跃比例' },
            // { id: 16, name: '人均游玩时长' }
          ],
          data: {
            columns: ['日期', '数据'],
            rows: [],
          },
        },
      ],
      DateData: [],
      chartExtend: chartExtend,
      dateList: [],
      exposureData: [],
      Pagination: {
        page: 1,
        page_size: 10,
      },
      exposureDataLoading: false,
      exporesureField: [
        {
          label: '日期',
          className: 'tb-data',
          prop: 'date',
        },
        {
          label: '广告按钮点击数',
          className: 'tb-hit',
          prop: 'hit',
        },
        {
          label: '广告按钮曝光数',
          className: 'tb-exposure',
          prop: 'exposure',
        },
        {
          label: '广告转化率',
          className: 'tb-rate',
          prop: 'rate',
        },
      ],
      endTime: '',
      startTime: '',
      totalCount: 0,
      DatapickerOptions: {
        //判断
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcurts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近3个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  filters: {
    regroupDate(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
    regroupTime(num) {
      return Number(num / 60).toFixed(1);
    },
    regroupMapType(val) {
      let type = '';
      switch (val) {
        case 1:
          type = '综合';
          break;
        case 2:
          type = '生存';
          break;
        case 3:
          type = '创造';
          break;
        case 4:
          type = '对战';
          break;
        case 5:
          type = '电路';
          break;
        case 6:
          type = '解密';
          break;
        case 7:
          type = '跑酷';
          break;
        case 8:
          type = '其他';
          break;
        case 9:
          type = '录像';
          break;
        default:
          break;
      }
      return type;
    },
    regroupMapStatus(val) {
      let status = ' ';
      if (val === 4 || val === 14) {
        status = '封禁';
      } else if (val === 10 || val === 13) {
        status = '审核成功';
      } else if (val === 2 || val === 3 || val === 7 || val === 8) {
        status = '隐藏';
      } else if (val === 17) {
        status = '上传成功';
      } else {
        status = '审核中';
      }
      return status;
    },
  },
  mounted() {
    this.init();
    this.getSectionDateData(7); // 默认造出近7天数据

    // this.get
  },
  watch: {
    // <!--时间周期变化更新数据-->
    // dayNum(val) {
    //   this.getSectionDateData(val);
    //   // this.getDataList();
    //   this.chartsArr.forEach((item, index) => {
    //     this.fetchMapDiagram(item.value, index);
    //   });
    // }
  },
  created() {
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.DateData = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
    this.mapId = this.$route.query.id;
    // if (this.mapId) {

    // }
  },
  methods: {
    init() {
      // console.log(12345);
      // console.log(this.mapId);
      // console.log(6789);
      if (this.mapId) {
        this.getData();
      }
      //地图详情页曝光埋点
      this.$log('map_details_show', 85416, { v7: 1 });
    },
    //请求数据
    async getData() {
      await this.getMotivateData();
      this.fetchMapDetail();
      this.chartsArr.forEach((item, index) => {
        this.fetchMapDiagram(item.value, index);
      });
    },
    clickBack() {
      this.$store.commit('SET_BACKLABEL', 1);
      this.$router.back(-1);
    },
    handlePDateBtnClicked() {
      //第一阶段显示一年的数据
      if (this.DateData) {
        //this.getSectionDateData(365);
        this.getRealTimeDateData();
        this.chartsArr.forEach((item, index) => {
          this.fetchMapDiagram(item.value, index);
        });
      } else {
        this.$message.error('请选择时间');
      }
    },
    //获取地图详情激励数据
    async getMotivateData() {
      const time = parseInt(new Date().getTime() / 1000);
      let data = {
        time: time,
        id: this.mapId,
        range: 3,
      };
      const res = await getSinMotivate(data);
      if (res.data.ret == 0) {
        this.single = res.data.msg;
      }
    },
    getCardDataList() {
      this.productData = [
        {
          title: '作品下载总次数',
          prop: 'download',
          value: (this.mapInfo.download | 0) + (this.single.download | 0),
          yes: (this.mapInfo.download_y | 0) + (this.single.y_download | 0),
        },
        {
          title: '作品浏览总次数',
          prop: 'browse',
          value: (this.mapInfo.browse | 0) + (this.single.browse | 0),
          yes: (this.mapInfo.browse_y | 0) + (this.single.y_browse | 0),
        },
      ];
      this.membersData = [
        // {
        //   title: '游戏总人数',
        //   prop: 'download',
        //   value: 234,
        //   yes: 36
        // },
        {
          title: '游戏总次数',
          prop: 'play_count',
          value: (this.mapInfo.play_count || 0) + (this.single.play_count | 0),
          yes:
            (this.mapInfo.play_count_y || 0) + (this.single.y_play_count | 0),
        },
        {
          title: '游戏总时长（分钟）',
          prop: 'play_time',
          value:
            (this.mapInfo.play_time / 60 || 0) +
            (this.single.play_time | 0) / 60,
          yes:
            (this.mapInfo.play_time_y / 60 || 0) +
            (this.single.y_play_time | 0) / 60,
        },
        {
          title: '次均游玩时长（分钟）',
          prop: 'play_avg_time',
          value:
            (this.mapInfo.play_avg_time / 60 || 0) +
            (this.single.play_avg_time | 0) / 60,
          yes:
            (this.mapInfo.play_avg_time_y / 60 || 0) +
            (this.single.y_play_avg_time | 0) / 60,
        },
        {
          title: '游戏人数',
          prop: 'player',
          value: (this.mapInfo.player || 0) + (this.single.player | 0),
          yes: (this.mapInfo.player_y || 0) + (this.single.y_player | 0),
        },
        // {
        //   title: '新增用户',
        //   prop: 'browse',
        //   value: 234,
        //   yes: 36
        // }
      ];
      this.overviewData = [
        {
          title: '评论数',
          prop: 'comment',
          value: this.mapInfo.comment || 0,
          yes: this.mapInfo.comment_y || 0,
        },
        {
          title: '收藏数',
          prop: 'collect',
          value: this.mapInfo.collect || 0,
          yes: this.mapInfo.collect_y || 0,
        },
        {
          title: '投块数',
          prop: 'block',
          value: this.mapInfo.block || 0,
          yes: this.mapInfo.block_y || 0,
        },
        {
          title: '点赞数',
          prop: 'praise',
          value: this.mapInfo.praise || 0,
          yes: this.mapInfo.praise_y || 0,
        },
      ];
      this.incomeData = [
        {
          title: '广告总收入',
          prop: 'ad_income',
          value: this.mapInfo.ad_income || 0,
          yes: this.mapInfo.ad_income_y || 0,
        },
        // {
        //   title: '会员收入',
        //   prop: 'browse',
        //   value: 234,
        //   yes: 36
        // },
        {
          title: '广告曝光总次数',
          prop: 'ad_count',
          value: this.mapInfo.ad_count || 0,
          yes: this.mapInfo.ad_count_y || 0,
        },
        // {
        //   title: '会员免广告曝光次数',
        //   prop: 'download',
        //   value: 234,
        //   yes: 36
        // },
        {
          title: '贡献点数量',
          prop: 'contribution',
          value: this.mapInfo.contribution || 0,
          yes: this.mapInfo.contribution_y || 0,
        },
        {
          title: '迷你点数量',
          prop: 'minipoint',
          value: this.mapInfo.minipoint || 0,
          yes: this.mapInfo.minipoint_y || 0,
        },
        {
          title: '迷你豆数量',
          prop: 'minibean',
          value: this.mapInfo.minibean || 0,
          yes: this.mapInfo.minibean_y || 0,
        },
      ];
    },
    changeLabel() {
      // console.log(this.activeLabel);
    },
    changeCard(index) {
      this.activeCard = index;
    },
    //改变日期范围事件触发
    changeDate(value) {
      const nowTime = new Date(new Date(new Date()).toDateString()).getTime();
      //判断选择时间是7天/30天/90天
      this.endTime =
        new Date(new Date(new Date()).toDateString()).getTime() - 1;
      this.DateData[1] = this.endTime - ONE_DAY_TIME;
      if (value == 7) {
        this.vid = 1;
        this.startTime = nowTime - 7 * 24 * 60 * 60 * 1000;
      } else if (value == 30) {
        this.vid = 2;
        this.startTime = nowTime - 30 * 24 * 60 * 60 * 1000;
      } else {
        this.vid = 3;
        this.startTime = nowTime - 90 * 24 * 60 * 60 * 1000;
      }
      this.DateData[0] = this.startTime;
      this.getSectionDateData(value);
      this.chartsArr.forEach((item, index) => {
        this.fetchMapDiagram(item.value, index);
      });
      //查询范围点击埋点
      this.$log('check_scope_click', 85417, { v7: 1, v8: this.vid });
    },

    // 获取近三十天的年月日，默认数据为0
    getSectionDateData(day) {
      this.dateList = [];
      let arr = [];
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(endDate.getDate() - day);
      while (endDate.getTime() - startDate.getTime() >= 0) {
        let year = startDate.getFullYear();
        let month =
          (startDate.getMonth() + 1).toString().length === 1
            ? '0' + (startDate.getMonth() + 1).toString()
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate().toString().length === 1
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          num: '0',
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      this.dateList = arr.slice(0, arr.length - 1);
    },
    //获取实时折线图时间范围
    getRealTimeDateData() {
      let day = new Date(this.DateData[1] - this.DateData[0]).getDate();
      this.dateList = [];
      let arr = [];
      let startDate = new Date(this.DateData[0]);
      let endDate = new Date(this.DateData[1]);
      //判断实时时间差是否在七天内
      if (day < 7) {
        startDate.setDate(endDate.getDate() - 7);
      }
      while (endDate.getTime() - startDate.getTime() >= 0) {
        let year = startDate.getFullYear();
        let month =
          (startDate.getMonth() + 1).toString().length === 1
            ? '0' + (startDate.getMonth() + 1).toString()
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate().toString().length === 1
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          num: '0',
        });

        startDate.setDate(startDate.getDate() + 1);
      }
      //判断选择的最后一天数据是否为当天
      let new_date1 = new Date(this.DateData[1]).toDateString();
      let new_date2 = new Date().toDateString();
      if (new_date1 == new_date2) {
        this.dateList = arr.slice(0, arr.length - 1);
      } else {
        this.dateList = arr.slice(0, arr.length);
      }
    },
    // 获取地图详情
    async fetchMapDetail() {
      this.loading = true;
      try {
        const res = await getMapDetail({ id: this.mapId });
        this.mapInfo = res.data;
        // this.getCardData()
        this.getCardDataList();
        this.isShowMapInfo = true;
        this.loading = false;
        this.export_custom = this.mapInfo.export_custom;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 获取地图各图表数据
    async fetchMapDiagram(dtype, index) {
      this.chartLoadingArr[index].state = true;
      try {
        const res = await getMapDiagram({
          id: this.mapId,
          dtype: dtype,
          start_time: parseInt(this.DateData[0] / 1000, 10),
          end_time: parseInt((this.DateData[1] + ONE_DAY_TIME) / 1000, 10),
        });
        this.getChartsData(index, res.data.list, dtype);
        this.chartLoadingArr[index].state = false;
      } catch (error) {
        this.chartLoadingArr[index].state = false;
        console.log(error);
      }
    },
    // 下载关键数据
    async fetchExport() {
      let data = {
        id: this.mapId,
        start_time: parseInt(this.DateData[0] / 1000, 10),
        end_time: parseInt((this.DateData[1] + ONE_DAY_TIME) / 1000, 10),
      };
      try {
        const res = await exportMapData(data);
        this.downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    // 下载关键数据
    async fetchCustomExport() {
      let data = {
        id: this.mapId,
        start_time: parseInt(this.DateData[0] / 1000, 10),
        end_time: parseInt((this.DateData[1] + ONE_DAY_TIME) / 1000, 10),
      };
      try {
        const res = await exportMapCustomData(data);
        this.downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    // 下载活跃数据
    async fetchAnalysis() {
      let data = {
        id: this.mapId,
        day: this.dayNum,
      };
      try {
        const res = await exportMapData(data);
        this.downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    // 计算图表数据
    getChartsData(index, list, dtype) {
      this.chartsArr[index].data = {
        columns: ['日期', '数据'],
        rows: [],
      };
      if (list.length) {
        this.dateList.forEach(date => {
          list.forEach(item => {
            if (date.date == item.date) {
              date = item;
            }
          });
          let num = 0;
          if (dtype == 4 || dtype == 16) {
            num = Number(date.num / 60).toFixed(2);
          } else if (dtype == 19) {
            num = Number(date.num).toFixed(4);
          }
          // else if (dtype == 18) {
          //   num = Number(date.num * 100).toFixed(2);
          // }
          else {
            num = Number(date.num).toFixed(4);
          }
          this.chartsArr[index].data.rows.push({
            日期: date.date,
            数据:
              dtype == 4 || dtype == 16
                ? Number(date.num / 60).toFixed(2)
                : dtype == 19
                ? Number(date.num).toFixed(4)
                : date.num,
          });
        });
      }
    },
    //获取曝光转化数据
    async getDataList() {
      this.exposureDataLoading = true;
      const res = await getExportsureData({
        id: this.mapId,
        page_size: this.Pagination.page_size,
        page: this.Pagination.page,
        day: this.dayNum,
        // start_time: parseInt(this.exposureDate[0] / 1000, 10),
        // end_time: parseInt((this.exposureDate[1] + ONE_DAY_TIME) / 1000, 10)
      });
      this.exposureDataLoading = false;
      //this.exposureData = res.data.list;
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.exposureData = list.map(item => {
            item.hit = item.hit == -1 ? '-' : item.hit;
            item.exposure = item.exposure == -1 ? '-' : item.exposure;
            return item;
          });
        }
        this.totalCount = parseInt(res.data.total_count || 0, 10);
      }
    },
    PaginationChange(currentPage) {
      this.Pagination.page = currentPage;
      // this.getDataList();
    },
    // 重组卡片数据
    getCardData() {
      this.mapData = {
        title: '下载互动',
        data: [
          {
            下载次数: this.mapInfo.download,
            '': '',
            评论数: this.mapInfo.comment,
          },
          {
            浏览次数: this.mapInfo.browse,
            游玩人次: this.mapInfo.play_count,
            '游玩时长(分钟)': Number(this.mapInfo.play_time / 60).toFixed(1),
          },
          {
            投块数: this.mapInfo.block,
            // 点赞数: this.mapInfo.praise,
            收藏数: this.mapInfo.collect,
            '今日下载(预估)': this.mapInfo.today_download,
          },
        ],
      };
      this.profitData = {
        title: '收益数据',
        data: [
          {
            广告营收: this.mapInfo.ad_income,
            '': '',
            广告展示:
              this.mapInfo.ad_count == -1 ? '--' : this.mapInfo.ad_count,
          },
          {
            贡献点: Number(this.mapInfo.contribution).toFixed(3),
            迷你豆: this.mapInfo.minibean,
            迷你点: this.mapInfo.minipoint,
          },
        ],
      };
    },
    // 切换折线图各图标的label
    chooseLabelFn(index, id) {
      console.log(55555);
      console.log(id);
      if (this.chartsArr[index].value != id) {
        this.chartsArr[index].value = id; // 高亮
        this.fetchMapDiagram(id, index);
      }
    },
    changeLabelFn(index, id) {
      if (this.chartsArr[index].value != id) {
        this.chartsArr[index].value = id; // 高亮
        this.fetchMapDiagram(id, index);
      }
    },
    exportFn() {
      this.fetchExport();
      //导出详细数据点击埋点
      this.epMapData();
    },
    exportCustomFn() {
      // TODO
      this.fetchCustomExport();
      //导出详细数据点击埋点
      // this.epMapData();
    },
    exportAnalysis() {
      this.fetchAnalysis();
    },
    epMapData() {
      this.$log('export_data_click', 85418, { v7: 1, v8: this.vid });
    },
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    submitCloseRoom() {
      if (this.closeTime === '') {
        this.$message({
          type: 'error',
          message: '请输入关闭时间',
        });
        return;
      }
      const closeTimeObj = {
        0: 3,
        1: 60,
        2: 120,
        3: 180,
        4: 240,
        5: 300,
      };
      this.$confirm(
        `即将在${
          closeTimeObj[this.closeTime]
        }秒钟后关闭当前地图的所有房间，是否确认？`,
        '关闭确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      ).then(async () => {
        await setCloseRoom({
          id: this.mapId,
          minute: this.closeTime,
        });
        this.$message({
          type: 'success',
          message: '设置成功!',
        });
        this.csRoomVisible = false;
      });
    },
    filterCloseTime(val) {
      const reg = /(^[0-5])$/;
      this.closeTime = reg.test(val) ? val : '';
    },
  },
};
</script>
<style lang="scss" scoped>
$--color-primary: #fd9b21;

#main {
  .title-wrap {
    font-size: 20px;
    color: #8c8c8c;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    margin-bottom: 8px;
    .title-name {
      cursor: pointer;
      width: 200px;
    }
  }
  .container {
    background: transparent;
    padding: 0;
    .block {
      background: #fff;
      margin-bottom: 20px;
      //padding: 18px 33px 20px;
      padding-top: 20px;
      padding-bottom: 20px;
      border-radius: 8px;
      .title-wrap1 {
        font-size: 24px;
        color: #595959;
        //padding-bottom: 24px;
        // border-bottom: 1px solid rgba(217, 217, 217, 1);
        // margin-bottom: 24px;
        i {
          margin-left: 4px;
        }
        .title-name {
          em {
            cursor: pointer;
          }
          label {
            color: #8c8c8c;
          }
        }
      }
      .data-table {
        margin-top: 28px;
        border: 1px solid #d9d9d9;
        overflow: hidden;
        border-radius: 3px;
        ::v-deep .el-table tr:last-child td {
          border-bottom: none;
        }
        ::v-deep .el-table::before {
          background: transparent;
        }
        ::v-deep .el-table th {
          background: #fafafa;
          line-height: 29px;
        }
        ::v-deep .el-table td {
          line-height: 29px;
          padding: 7px 0 6px;
        }
      }
      // .title-desc {
      //   font-size: 14px;
      //   color: #8c8c8c;
      //   margin-top: 8px;
      //   .title-link {
      //     color: #2b6ddf;
      //     margin-left: 22px;
      //   }
      // }
      .content-inner-wrap,
      .content-wrapper {
        .el-table {
          .el-button {
            margin-left: 0;
            color: #2b6ddf;
          }
        }
        .data-filter {
          margin-bottom: 22px;
          .mgr25 {
            margin-right: 25px;
          }
          .el-radio.is-bordered.is-checked {
            background-color: #fffaed;
          }
          ::v-deep .el-radio.is-bordered {
            .el-radio__input {
              display: none;
              //margin-right: 10px;
            }
          }
          .el-radio--medium.is-bordered {
            padding: 8px 27px 2px 17px;
            height: 32px;
            margin-right: 1px;
          }
        }
        ::v-deep .el-upload-list--picture {
          margin-bottom: 12px;
          .el-upload-list__item {
            padding: 0;
            width: 100px;
            height: 100px;
            border-radius: 0;
            border: none;
            .el-icon-close {
              z-index: 9;
            }
          }
          .el-upload-list__item-thumbnail {
            width: 100px;
            height: 100px;
            margin-left: 0;
            float: none;
            border-radius: 0;
          }
        }
        ::v-deep .uploadBtn {
          padding: 4px 16px;
          > span {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            // .icon-upload {
            //   width: 28px;
            //   height: 28px;
            //   background: url('../images/icon-upload.svg') 0 0 no-repeat;
            //   background-size: 28px;
            //   margin-right: 11px;
            // }
            span {
              font-size: 16px;
              line-height: 21px;
              color: #595959;
            }
          }
        }
      }
      .data-filter-page {
        margin-top: 44px;
        text-align: center;
        margin-bottom: 12px !important;
        ::v-deep .el-pagination.is-background .el-pager li,
        ::v-deep .el-pagination.is-background .btn-prev,
        ::v-deep .el-pagination.is-background .btn-next {
          width: 31px;
          height: 31px;
          border-radius: 4px;
          margin: 0 4.5px;
          background-color: #fff;
          color: #8c8c8c;
          border: 1px solid #d9d9d9;
        }
        ::v-deep
          .el-pagination.is-background
          .el-pager
          li:not(.disabled).active {
          background-color: #fffaed;
          color: #fd9b21;
          border-color: #ffc973;
        }
      }
    }
  }
  .overview {
    position: relative;
    .close-cs-room {
      position: absolute;
      right: 10px;
      top: 28px;
      .el-icon-setting {
        cursor: pointer;
        font-size: 22px;
      }
    }
    .help-right {
      float: right;
    }
    .basic-info {
      display: flex;
      justify-content: space-between;

      .map-info {
        margin-top: 32px;
        display: flex;
        height: 210px;
        .map-img-wrap {
          width: 305px;
          height: 170px;
          margin-right: 20px;
          position: relative;
          .corner {
            width: 50px;
            position: absolute;
            top: 0;
            right: 0;
          }
          .map-img {
            width: 305px;
            height: 170px;
          }
        }
        .map-detail {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          .map-name {
            font-size: 20px;
            margin-bottom: 12px;
            color: #262626;
          }
          .map-type {
            // color: #50a3f1;
            // margin-right: 10px;
            // border: 1px solid #50a3f1;
            // border-radius: 4px;
            // padding: 4px 20px;
            background-color: rgba(255, 249, 235, 1);
            border-radius: 4px;
            font-size: 14px;
            margin-bottom: 12px;
            color: #ffcc40;
            padding: 6px 24px;
          }
          .map-topic {
            font-size: 16px;
            //  font-family: MicrosoftYaHei;
            margin-top: 12px;
            // margin-bottom: 12px;
            color: #ffcc40;
            line-height: 21px;
          }
          .map-status {
            height: 22px;
            font-size: 16px;
            margin-top: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            margin-bottom: 12px;
            color: #262626;
            line-height: 22px;
          }
          .map-update {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #878d99;
            line-height: 20px;
          }
        }
      }
    }
    .tab-wrap {
      margin-top: 25px;
      font-size: 18px;
      ::v-deep.el-tabs__item.is-top {
        font-size: 18px;
      }
    }
    .data-wrap {
      background: #fafafa;
      margin-top: 30px;
      border-radius: 4px;
      //color: #8c8c8c;
      .complex-wrap {
        min-height: 574px;
        .date-label {
          //float: right;
          display: flex;
          justify-content: flex-end;
          margin-right: 10px;
          color: #8c8c8c;
          padding: 10px 10px 15px;
        }
        .card-wrap {
          .card-box {
            #card {
              display: flex;
              justify-content: flex-start;
              //margin-left: 20px;
              flex-wrap: wrap;
              margin-left: -15px;
              .card-wrap {
                background: #fff;
                margin-left: 25px;
                border: 1px solid #ddd;
                border-radius: 8px;
                padding: 13px 18px;
              }
            }
            .title {
              font-size: 16px;
              margin-bottom: 15px;
            }
          }
        }
      }
    }
    .card-info {
      display: flex;
      justify-content: space-between;
      margin-top: 26px;
    }
  }
  .charts-detail-wrap {
    margin-top: 36px;
    h2 {
      font-size: 24px;
    }
    .charts-title {
      font-size: 20px;
      display: flex;
      justify-content: space-between;
    }
    .charts-chooseDay {
      margin: 20px 0;
      display: flex;
      .date-box {
        display: flex;
        flex: 1;
      }
      .data-filter {
        .mgr25 {
          margin-right: 25px;
        }
        .search_btn {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          border-left: 0;
          color: #595959;
          border-right: 1px solid #d9d9d9;
          border-top: 1px solid #d9d9d9;
          border-bottom: 1px solid #d9d9d9;
          background-color: #f4f4f5;
        }
      }
      .date-wrap {
        margin-left: 15px;
      }
      .choose-label {
        margin-right: 24px;
      }
      .download-wrap {
        cursor: pointer;
        color: #2b6ddf;
        font-size: 14px;
        padding-top: 10px;
        margin-right: 10px;
        img {
          margin-right: 8px;
        }
      }
    }
    .charts-detail {
      margin-bottom: 30px;
      .title {
        color: #8c8c8c;
        margin-bottom: 17px;
      }
      .btn-option {
        display: inline-block;
        width: auto;
        padding: 0 10px;
        height: 32px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        margin-right: 16px;
        cursor: pointer;
        line-height: 32px;
        text-align: center;
      }
      .active-chart-table {
        color: $--color-primary;
        background: #fffaed;
        border: 1px solid #ffc973;
        cursor: initial;
      }
    }

    .el-select.el-select--small {
      width: 84px;
      height: 36px;
    }
  }
  .img-no-data {
    text-align: center;
  }

  // ::v-deep .el-input__inner {
  //   width: 84px;
  //   height: 36px;
  // }
  .img-no-data {
    margin-top: 30px;
    text-align: center;
    background: url('../../assets/images/img_bg_charts_no_data.png') no-repeat;
    height: 218px;
    img {
      margin-top: -30px;
      width: 160px;
      height: 160px;
    }
    p {
      font-size: 16px;
      color: #8c8c8c;
    }
  }
  .link-txt {
    color: #999999;
    text-decoration: none;
  }
}
// .el-input--small .el-input__inner {
//   height: 32px;
//   width: 40px;
// }
</style>
